import React from 'react'
import { DropdownMenuItems, DropdownMenuItemType, FlagIconComponent } from '@nominex/dex-uikit'

export const telegramLinks: DropdownMenuItems[] = [
  {
    label: 'Nominex News',
    href: 'https://t.me/nominex_announcements',
    iconComponent: <FlagIconComponent countryCode="GB" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Nominex Официальный',
    href: 'https://t.me/nominex_news_ru',
    iconComponent: <FlagIconComponent countryCode="RU" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Nominex Canal Español',
    href: 'https://t.me/nominex_news_spanish',
    iconComponent: <FlagIconComponent countryCode="ES" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'English chat',
    href: 'https://t.me/NominexExchange',
    iconComponent: <FlagIconComponent countryCode="GB" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Сhat en español',
    href: 'https://t.me/NominexSpanish',
    iconComponent: <FlagIconComponent countryCode="ES" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Русский чат',
    href: 'https://t.me/NominexRussian',
    iconComponent: <FlagIconComponent countryCode="RU" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Türkçe sohbet',
    href: 'https://t.me/NominexTurkish',
    iconComponent: <FlagIconComponent countryCode="TR" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
  {
    label: 'Indian chat',
    href: 'https://t.me/NominexIndian',
    iconComponent: <FlagIconComponent countryCode="IN" />,
    type: DropdownMenuItemType.EXTERNAL_LINK,
  },
]
